var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5822_270527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 3H12.9998V0H10.9998V3H8.49976C7.30669 3.00132 6.16286 3.47585 5.31924 4.31948C4.47561 5.16311 4.00108 6.30693 3.99976 7.5V16C3.99976 18.1217 4.84261 20.1566 6.3429 21.6569C7.84319 23.1571 9.87802 24 11.9998 24C14.1215 24 16.1563 23.1571 17.6566 21.6569C19.1569 20.1566 19.9998 18.1217 19.9998 16V7.5C19.9984 6.30693 19.5239 5.16311 18.6803 4.31948C17.8366 3.47585 16.6928 3.00132 15.4998 3ZM17.9998 16C17.9998 17.5913 17.3676 19.1174 16.2424 20.2426C15.1172 21.3679 13.5911 22 11.9998 22C10.4085 22 8.88233 21.3679 7.75712 20.2426C6.6319 19.1174 5.99976 17.5913 5.99976 16V7.5C5.99976 6.83696 6.26315 6.20107 6.73199 5.73223C7.20083 5.26339 7.83671 5 8.49976 5H15.4998C16.1628 5 16.7987 5.26339 17.2675 5.73223C17.7364 6.20107 17.9998 6.83696 17.9998 7.5V16Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 7.00031H10.9995V11.0003H12.9995V7.00031Z",
    fill: "#1F9FFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5822_270527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseScroll);
export default __webpack_public_path__ + "static/media/mouse-scroll.de01d71594a46e4b392c8502c73f24e3.svg";
export { ForwardRef as ReactComponent };